// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { infoCardListStyles } from "@rpsc/App/Widgets/Basic/InfoCardList";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

infoCardListStyles.topicsFilterWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        margin-bottom: 20px;
        align-items: flex-end;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};

infoCardListStyles.topicFilterSelect = {
    mergeCss: true,
    labelProps: {
        size: 14,
        color: "text",
        css: css`
            width: auto;
            padding: 4px 8px 0 0;
            line-height: 22px;
            font-weight: ${fontConfig.weight.regular};
        `,
    },
    cssOverrides: {
        formField: css`
            width: auto;
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
        formInputWrapper: css`
            width: 263px;
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    },
    css: css`
        max-height: 28px;
    `,
};

infoCardListStyles.resetFilterButton = {
    css: css`
        min-height: 28px;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
    typographyProps: {
        size: 11,
    },
};

infoCardListStyles.wrapper = {
    css: css`
        display: grid;
        gap: 22px;
        grid-auto-rows: 1fr;
        ${({ maxNumOfCardsPerRow, numOfCardPerRowTablet }: any) => {
            return css`
                grid-template-columns: repeat(${maxNumOfCardsPerRow}, 1fr);
                ${xScreen("lte", "md")} {
                    grid-template-columns: repeat(${numOfCardPerRowTablet}, 1fr);
                }
                ${xScreen("lte", "sm")} {
                    grid-template-columns: 1fr;
                }
            `;
        }};
    `,
};

infoCardListStyles.cardWrapper = {
    css: css`
        height: 100%;
    `,
};
